import * as z from "zod";
import { mutator } from "./mutator";

export const removeCustomAvatar = mutator({
  schema: z.object({}),
  resolve: {},
  permissions: { none: "clears only the calling user’s own avatar" },
  fn: async ({ tx, ctx }) => {
    await tx.mutate.user.update({
      id: ctx.userId,
      customAvatarKey: null,
    });
  },
});
